var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1498 11.5153H11.3819L11.1098 11.2529C12.0623 10.1448 12.6358 8.70628 12.6358 7.14138C12.6358 3.65196 9.80732 0.823486 6.3179 0.823486C2.82847 0.823486 0 3.65196 0 7.14138C0 10.6308 2.82847 13.4593 6.3179 13.4593C7.88279 13.4593 9.32133 12.8858 10.4294 11.9333L10.6918 12.2054V12.9733L15.5517 17.8235L17 16.3752L12.1498 11.5153ZM6.3179 11.5153C3.89766 11.5153 1.94397 9.56162 1.94397 7.14138C1.94397 4.72114 3.89766 2.76745 6.3179 2.76745C8.73814 2.76745 10.6918 4.72114 10.6918 7.14138C10.6918 9.56162 8.73814 11.5153 6.3179 11.5153Z",
    fill: "#2253FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlue);
export default __webpack_public_path__ + "static/media/IconSearchBlue.ae166414b913331195eea5c44d054c25.svg";
export { ForwardRef as ReactComponent };